import React, { FC, useCallback } from "react";
import { ChatServerButton } from "../../xapp/ChatServerMessage";
import { ActionButton } from "../ActionButton";

export interface ChatActionButtonProps {
    readonly button: ChatServerButton;
    onClick(button: ChatServerButton): void;
}

const ChatActionButtonInner: FC<ChatActionButtonProps> = props => {

    const { button, onClick } = props;

    const handleButton = useCallback(() => {
        onClick(button);
    }, [button, onClick]);

    return (
        <ActionButton onClick={handleButton} addClass="button-card" label={button.label} />
    );
};

export const ChatActionButton = React.memo(ChatActionButtonInner);